import axios from 'axios';
import * as rax from 'retry-axios';

const axiosConfig = {
    baseURL: '/api'
};

const axiosApi = axios.create(axiosConfig);
const axiosRetryApi = axios.create(axiosConfig);

axiosRetryApi.defaults.raxConfig = {
    instance: axiosRetryApi,
    // retry 30 times
    retry: 30,
    // retry every 3 seconds
    retryDelay: 3000,
    backoffType: 'static',
    // added in 401 to the list of defaults and removed 5xx errors because 5xx means something bad happened, wouldn't
    // want to continue retrying if something bad happened because this could cascade into more bad things happening.
    statusCodesToRetry: [[100, 199], [401, 401], [429, 429]],
    // added in 'POST' to the list of defaults
    httpMethodsToRetry: ['GET', 'HEAD', 'OPTIONS', 'DELETE', 'PUT', 'POST'],
};
rax.attach(axiosRetryApi);

export {
    axiosApi,
    axiosRetryApi,
}
